import * as React from 'react';
import TableCell from '@mui/material/TableCell';

const TextDataCell = ({ column, value }) => (
  <TableCell key={column.id} align={column.align}>
    {column.render(value)}
  </TableCell>
);

export default TextDataCell;
